'use client';

import _defineProperty from "/codebuild/output/src2481/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import cx from 'clsx';
import '../../Checkbox/Checkbox.mjs';
import '../../Checkbox/CheckboxGroup/CheckboxGroup.mjs';
import { CheckIcon } from '../../Checkbox/CheckIcon.mjs';
import '../../Checkbox/CheckboxIndicator/CheckboxIndicator.mjs';
import '../../Checkbox/CheckboxCard/CheckboxCard.mjs';
import '../../Checkbox/CheckboxCard/CheckboxCard.context.mjs';
import '../../Checkbox/CheckboxGroup.context.mjs';
import { ScrollArea } from '../../ScrollArea/ScrollArea.mjs';
import { Combobox } from '../Combobox.mjs';
import { defaultOptionsFilter } from './default-options-filter.mjs';
import { isEmptyComboboxData } from './is-empty-combobox-data.mjs';
import { isOptionsGroup } from './is-options-group.mjs';
import { validateOptions } from './validate-options.mjs';
import classes from '../Combobox.module.css.mjs';
function isValueChecked(value, optionValue) {
  return Array.isArray(value) ? value.includes(optionValue) : value === optionValue;
}
function Option(_ref) {
  var data = _ref.data,
    withCheckIcon = _ref.withCheckIcon,
    value = _ref.value,
    checkIconPosition = _ref.checkIconPosition,
    unstyled = _ref.unstyled,
    renderOption = _ref.renderOption;
  if (!isOptionsGroup(data)) {
    var checked = isValueChecked(value, data.value);
    var check = withCheckIcon && checked && /* @__PURE__ */jsx(CheckIcon, {
      className: classes.optionsDropdownCheckIcon
    });
    var defaultContent = /* @__PURE__ */jsxs(Fragment, {
      children: [checkIconPosition === "left" && check, /* @__PURE__ */jsx("span", {
        children: data.label
      }), checkIconPosition === "right" && check]
    });
    return /* @__PURE__ */jsx(Combobox.Option, {
      value: data.value,
      disabled: data.disabled,
      className: cx(_defineProperty({}, classes.optionsDropdownOption, !unstyled)),
      "data-reverse": checkIconPosition === "right" || void 0,
      "data-checked": checked || void 0,
      "aria-selected": checked,
      active: checked,
      children: typeof renderOption === "function" ? renderOption({
        option: data,
        checked: checked
      }) : defaultContent
    });
  }
  var options = data.items.map(function (item) {
    return /* @__PURE__ */jsx(Option, {
      data: item,
      value: value,
      unstyled: unstyled,
      withCheckIcon: withCheckIcon,
      checkIconPosition: checkIconPosition,
      renderOption: renderOption
    }, item.value);
  });
  return /* @__PURE__ */jsx(Combobox.Group, {
    label: data.group,
    children: options
  });
}
function OptionsDropdown(_ref2) {
  var data = _ref2.data,
    hidden = _ref2.hidden,
    hiddenWhenEmpty = _ref2.hiddenWhenEmpty,
    filter = _ref2.filter,
    search = _ref2.search,
    limit = _ref2.limit,
    maxDropdownHeight = _ref2.maxDropdownHeight,
    _ref2$withScrollArea = _ref2.withScrollArea,
    withScrollArea = _ref2$withScrollArea === void 0 ? true : _ref2$withScrollArea,
    _ref2$filterOptions = _ref2.filterOptions,
    filterOptions = _ref2$filterOptions === void 0 ? true : _ref2$filterOptions,
    _ref2$withCheckIcon = _ref2.withCheckIcon,
    withCheckIcon = _ref2$withCheckIcon === void 0 ? false : _ref2$withCheckIcon,
    value = _ref2.value,
    checkIconPosition = _ref2.checkIconPosition,
    nothingFoundMessage = _ref2.nothingFoundMessage,
    unstyled = _ref2.unstyled,
    labelId = _ref2.labelId,
    renderOption = _ref2.renderOption,
    scrollAreaProps = _ref2.scrollAreaProps,
    ariaLabel = _ref2["aria-label"];
  validateOptions(data);
  var shouldFilter = typeof search === "string";
  var filteredData = shouldFilter ? (filter || defaultOptionsFilter)({
    options: data,
    search: filterOptions ? search : "",
    limit: limit !== null && limit !== void 0 ? limit : Infinity
  }) : data;
  var isEmpty = isEmptyComboboxData(filteredData);
  var options = filteredData.map(function (item) {
    return /* @__PURE__ */jsx(Option, {
      data: item,
      withCheckIcon: withCheckIcon,
      value: value,
      checkIconPosition: checkIconPosition,
      unstyled: unstyled,
      renderOption: renderOption
    }, isOptionsGroup(item) ? item.group : item.value);
  });
  return /* @__PURE__ */jsx(Combobox.Dropdown, {
    hidden: hidden || hiddenWhenEmpty && isEmpty,
    children: /* @__PURE__ */jsxs(Combobox.Options, {
      labelledBy: labelId,
      "aria-label": ariaLabel,
      children: [withScrollArea ? /* @__PURE__ */jsx(ScrollArea.Autosize, _objectSpread(_objectSpread({
        mah: maxDropdownHeight !== null && maxDropdownHeight !== void 0 ? maxDropdownHeight : 220,
        type: "scroll",
        scrollbarSize: "var(--combobox-padding)",
        offsetScrollbars: "y"
      }, scrollAreaProps), {}, {
        children: options
      })) : options, isEmpty && nothingFoundMessage && /* @__PURE__ */jsx(Combobox.Empty, {
        children: nothingFoundMessage
      })]
    })
  });
}
export { OptionsDropdown };